export default {"src":"/_next/static/image/public/images/flags/flag_1268.90ac634098455bc862e5f7a2214468f5.svg","height":16,"width":24};